// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Block      = require("bs-platform/lib/js/block.js");
var Curry      = require("bs-platform/lib/js/curry.js");
var Printf     = require("bs-platform/lib/js/printf.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");

function generateColor(status, boardSize, rowIndex, cellIndex) {
  var red = Caml_int32.imul(Caml_int32.div(256, boardSize), rowIndex + 1 | 0);
  var green = Caml_int32.imul(Caml_int32.div(256, boardSize), cellIndex + 1 | 0);
  var alpha = status !== 1 ? 0.3 : 1.0;
  return Curry._4(Printf.sprintf(/* Format */[
                  /* String_literal */Block.__(11, [
                      "rgba(",
                      /* Int */Block.__(4, [
                          /* Int_i */3,
                          /* No_padding */0,
                          /* No_precision */0,
                          /* String_literal */Block.__(11, [
                              ", ",
                              /* Int */Block.__(4, [
                                  /* Int_i */3,
                                  /* No_padding */0,
                                  /* No_precision */0,
                                  /* String_literal */Block.__(11, [
                                      ", ",
                                      /* Int */Block.__(4, [
                                          /* Int_i */3,
                                          /* No_padding */0,
                                          /* No_precision */0,
                                          /* String_literal */Block.__(11, [
                                              ", ",
                                              /* Float */Block.__(8, [
                                                  /* Float_f */0,
                                                  /* No_padding */0,
                                                  /* No_precision */0,
                                                  /* Char_literal */Block.__(12, [
                                                      /* ")" */41,
                                                      /* End_of_format */0
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                  "rgba(%i, %i, %i, %f)"
                ]), red, green, 128, alpha);
}

function make($staropt$star, $staropt$star$1, $staropt$star$2, $staropt$star$3, _) {
  var v = $staropt$star ? $staropt$star[0] : 0;
  var size = $staropt$star$1 ? $staropt$star$1[0] : 1;
  var rowIndex = $staropt$star$2 ? $staropt$star$2[0] : 1;
  var cellIndex = $staropt$star$3 ? $staropt$star$3[0] : 1;
  var c = generateColor(v, size, rowIndex, cellIndex);
  return /* record */[
          /* value */v,
          /* color */c
        ];
}

exports.generateColor = generateColor;
exports.make          = make;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/cellData.re
// module id = 50
// module chunks = 0